<template>
  <div>
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon color="primary" v-bind="attrs" v-on="on">
          <v-icon small color="primary" class=""
            >mdi-information-outline</v-icon
          >
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> More Info </v-card-title>

        <v-card-text class="pa-4">
          <vs-eye
            :style="`width: 50%; margin-left: 15%`"
            :size="isMobile ? 130 : 270"
            :eye="eye"
            :uncorrectedRx="rx"
            :accommodation="accommodation"
            :maxAccom="accomAbility"
            :correctiveLens="correctionType"
            :hideAccom="true"
          ></vs-eye>
          <table class="borderedTable mx-auto mt-4">
            <tr>
              <th>Looking At</th>
              <td>
                {{ targetDefs.label }}: {{ targetDefs.shortDistance }}.
                <!-- {{ numToDiopterString(targetDefs.diopters) }} D -->
              </td>
            </tr>
            <tr>
              <th>Correction Type</th>
              <td>{{ correctionText }}</td>
            </tr>
            <tr>
              <th>Accommodation Available</th>
              <td>
                <v-progress-linear
                  :value="maxAccom * 15"
                  color="#90CAF9"
                  class="mx-1"
                  height="6"
                  rounded
                  :style="`width:${isMobile ? 100 : 200}px;`"
                ></v-progress-linear>
              </td>
            </tr>
            <tr>
              <th>Accommodation Needed</th>
              <td>
                <v-progress-linear
                  :value="accomNeeded * 15"
                  color="#90CAF9"
                  class="mx-1"
                  height="6"
                  rounded
                  :style="`width:${isMobile ? 100 : 200}px;`"
                ></v-progress-linear>
              </td>
            </tr>
            <tr>
              <th>Current Accommodation</th>
              <td>
                <v-progress-linear
                  :value="accommodation * 15"
                  color="#90CAF9"
                  class="mx-1"
                  height="6"
                  rounded
                  :style="`width:${isMobile ? 100 : 200}px;`"
                ></v-progress-linear>
              </td>
            </tr>
          </table>

          <br />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VsEye from "./VsEye.vue";
// import VsEyeMoreInfo from "./VsEyeMoreInfo.vue";
// import BlurImage from "./BlurImage.vue";
import RxMethods from "@/assets/js/cls/RxMethods";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "VsEyeMoreInfo",
  components: {
    VsEye,
    // BlurImage,
    // VsEyeMoreInfo,
  },
  props: {
    rx: null,
    accommodation: null,
    maxAccom: null,
    correctiveLens: null,
    correctionType: { type: String, default: "none" },
    eye: null,
    accomAbility: null,
    lookingAt: null,
    correctionText: null,
    uncorrectedRx: null,
  },
  mixins: [RxMethods, VsDefinitions],
  data: function () {
    return { dialog: false, accomNeeded: 0 };
  },
  methods: {
    calculateAccomNeeded() {
      let targetDiopters = this.targetDefs?.diopters;
      //   if (!this.uncorrectedRx || targetDiopters) this.accomNeeded = 0;
      this.accomNeeded = this.accomNeededForTarget(
        this.uncorrectedRx,
        targetDiopters
      );
      //   console.log(this.accomNeeded);
    },
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
    targetDefs: function () {
      return VsDefinitions.lookingAtData[this.lookingAt];
    },
    // accomForTarget: function () {
    //   let targetDiopters = this.targetDefs?.diopters;
    //   console.log("here");
    //   if (!this.uncorrectedRx || !targetDiopters) return 0;
    //   return this.accomNeededForTarget(this.uncorrectedRx, targetDiopters);
    // },
  },
  watch: {
    uncorrectedRx: {
      handler: function () {
        this.calculateAccomNeeded();
      },
      deep: true,
    },
  },
  mounted() {
    this.calculateAccomNeeded();
  },
};
</script>

<style scoped></style>
